import { render, staticRenderFns } from "./AnalyzeResult.vue?vue&type=template&id=21ff94a4&scoped=true"
import script from "./AnalyzeResult.vue?vue&type=script&lang=js"
export * from "./AnalyzeResult.vue?vue&type=script&lang=js"
import style0 from "./AnalyzeResult.vue?vue&type=style&index=0&id=21ff94a4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff94a4",
  null
  
)

export default component.exports